import React from "react";
import { ShoppingBag, MessageCircle, Truck } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { useChat } from "../../context/ChatContext";

const InfoBanner = () => {
  const { setOpen: openCart, itemCount } = useCart();
  const { setOpen: openChat } = useChat();
  return (
    <div className="w-full bg-[#060A14] border-b border-white/10 text-[#E5E4E2]" data-testid="info-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[12px] tracking-[0.18em] uppercase">
        <span className="flex items-center gap-2" data-testid="info-shipping">
          <Truck className="w-3.5 h-3.5 text-[#C0C0C0]" />
          Spedizione 3–5 giorni
        </span>
        <span className="hidden sm:inline text-white/20">•</span>
        <button onClick={() => openChat(true)} data-testid="info-chat-link"
                className="flex items-center gap-2 hover:text-white transition-colors">
          <MessageCircle className="w-3.5 h-3.5 text-emerald-400" />
          Parla con Leo
        </button>
        <span className="hidden sm:inline text-white/20">•</span>
        <button onClick={() => openCart(true)} data-testid="info-cart-link"
                className="flex items-center gap-2 hover:text-white transition-colors">
          <ShoppingBag className="w-3.5 h-3.5 text-[#C0C0C0]" />
          Carrello {itemCount > 0 && <span className="text-white">({itemCount})</span>}
        </button>
      </div>
    </div>
  );
};

export default InfoBanner;
